import { FormValues, validate, emptyValues } from './form-data';
import { useStateSelector } from 'shared/store';
import { FormDialog } from 'shared/ui/form-dialog';
import { useAddMediaDialog } from './lib';
import { Stack } from '@mui/material';
import { Field } from 'formik';
import { TextField } from 'formik-mui';
import { MediaTypePickerField } from 'entities/media/media-type-picker';
import { CityPicker } from 'entities/geo/cities/city-picker';
import { GeoPicker } from 'features/geo/picker/geo-picker';
import { RegionPicker } from 'shared/ui/formik-fields/region-picker';
import { CountryPicker } from 'shared/ui/formik-fields/country-picker';

type Props = {
  onSubmit: (data: FormValues) => Promise<void>;
  initialValues?: Partial<FormValues>;
}

export const MediaCreateDialog = ({ onSubmit, initialValues }: Props) => {
  const isOpen = useStateSelector(state => state.ui.media.addNewMediaDialogOpen);
  const { closeDialog } = useAddMediaDialog();

  return (
    <FormDialog
      onClose={closeDialog}
      open={isOpen}
      renderTitle="Новое СМИ"
      renderForm={(formikProps) => {
        const renderGeoField = () => {
          switch (formikProps.values.placement) {
          case 'federal':
            return (
              <Field
                name='countryId'
                label='Страна'
                required
                component={CountryPicker}
              />
            );
          case 'regional':
            return (
              <Field
                name='regionId'
                label='Регион'
                required
                component={RegionPicker}
              />
            );
          case 'local':
            return (
              <Field
                name='cityId'
                label='Город'
                required
                component={CityPicker}
              />
            );
          default:
            return null;
          }
        };

        return (
          <>
            <Stack direction="column" spacing={2}>
              <Field
                name="name"
                label="Название"
                required
                component={TextField}
              />
              <Field
                name="mediaTypeId"
                select
                label="Тип"
                required
                component={MediaTypePickerField}
              />
              <GeoPicker
                name='placement'
                label='Размещение'
                required
              />
              {renderGeoField()}
            </Stack>
          </>
        );
      }}
      initialValues={{ ...emptyValues, ...(initialValues ?? {}) }}
      onSubmit={onSubmit}
      validate={validate}
      dialogProps={{
        fullWidth: true,
        maxWidth: 'lg'
      }} />
  );
};
